import { getProvider } from './registry';
import type { ThirdPartyMode } from './types';
import { BLOB_RESERVED_KEYS } from './constants';

export function validateBlobConfigJson(
  value: string,
): { ok: true; parsed: Record<string, unknown> } | { ok: false; error: string } {
  if (!value?.trim()) {
    return { ok: false, error: 'Invalid or empty JSON. "provider" is required.' };
  }
  try {
    const parsed = JSON.parse(value) as Record<string, unknown>;
    if (typeof parsed?.provider !== 'string') {
      return { ok: false, error: 'Invalid config: "provider" is required.' };
    }
    return { ok: true, parsed };
  } catch {
    return { ok: false, error: 'Invalid JSON. Enter valid JSON.' };
  }
}

export function enrichMergedWithObjectDefaults(
  merged: Record<string, unknown>,
  providerId: string,
  mode: ThirdPartyMode,
): Record<string, unknown> {
  const config = getProvider(providerId);
  if (!config) return merged;
  let out = merged;
  if (
    mode === 'pull' &&
    config.pullConfig &&
    (merged.pullObjectType === undefined || merged.pullObjectType === null)
  ) {
    const defaultType = config.pullConfig.objectTypes?.[0]?.value;
    if (defaultType !== undefined) out = { ...out, pullObjectType: defaultType };
  }
  if (
    mode === 'push' &&
    config.pushConfig &&
    (merged.pushAction === undefined || merged.pushAction === null)
  ) {
    const defaultAction = config.pushConfig.actions?.[0]?.value;
    if (defaultAction !== undefined) out = { ...out, pushAction: defaultAction };
  }
  return out;
}

export function serializeNodeToBlobConfig(
  data: Record<string, unknown>,
): string {
  const out: Record<string, unknown> = {};
  for (const k of Object.keys(data)) {
    if (BLOB_RESERVED_KEYS.has(k)) continue;
    if (k.endsWith('Data')) continue;
    out[k] = data[k];
  }
  return JSON.stringify(out, null, 2);
}
